var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIllustration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 331,
    height: 300,
    viewBox: "0 0 331 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M303.068 103.635L213.235 161.507C210.605 163.207 207.404 163.799 204.336 163.152C201.268 162.505 198.584 160.672 196.875 158.057C195.165 155.442 194.571 152.258 195.221 149.207C195.872 146.155 197.714 143.486 200.344 141.786L290.177 83.9138C292.807 82.2137 296.007 81.622 299.075 82.269C302.143 82.916 304.827 84.7487 306.537 87.3639C308.246 89.9791 308.841 93.1625 308.191 96.2139C307.54 99.2653 305.697 101.935 303.068 103.635Z",
    fill: "#389BF3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M183.022 181.272L122.955 220.091C120.319 221.791 117.113 222.38 114.04 221.729C110.968 221.078 108.282 219.24 106.572 216.619C104.863 213.997 104.27 210.808 104.925 207.753C105.58 204.697 107.428 202.025 110.064 200.325L170.087 161.551C171.389 160.709 172.845 160.131 174.371 159.848C175.898 159.566 177.466 159.586 178.985 159.906C180.504 160.227 181.945 160.841 183.225 161.716C184.506 162.59 185.6 163.706 186.447 165.001C187.293 166.296 187.875 167.744 188.158 169.262C188.442 170.781 188.422 172.34 188.1 173.851C187.778 175.362 187.16 176.795 186.281 178.068C185.402 179.342 184.28 180.43 182.978 181.272H183.022Z",
    fill: "#FF9D23"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M260.905 90.013L171.072 147.885C169.77 148.727 168.314 149.306 166.787 149.588C165.26 149.87 163.692 149.85 162.173 149.53C160.654 149.21 159.213 148.595 157.933 147.721C156.653 146.846 155.558 145.73 154.712 144.435C153.865 143.14 153.284 141.692 153 140.174C152.716 138.655 152.736 137.096 153.058 135.585C153.38 134.074 153.998 132.641 154.877 131.368C155.756 130.095 156.879 129.006 158.181 128.164L248.014 70.292C250.646 68.7886 253.757 68.3457 256.707 69.0544C259.657 69.7631 262.221 71.5695 263.873 74.1018C265.525 76.6342 266.137 79.6998 265.585 82.6678C265.033 85.6359 263.358 88.2805 260.905 90.0576V90.013Z",
    fill: "#AA7DFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M140.859 167.606L80.7908 206.469C79.488 207.413 78.0056 208.083 76.434 208.438C74.8624 208.793 73.2345 208.825 71.6498 208.534C70.065 208.242 68.5567 207.632 67.2168 206.742C65.8768 205.851 64.7335 204.698 63.8564 203.353C62.9794 202.009 62.3871 200.5 62.1157 198.92C61.8443 197.34 61.8995 195.722 62.2779 194.164C62.6563 192.606 63.3499 191.141 64.3165 189.858C65.2831 188.575 66.5024 187.502 67.8999 186.704L127.968 147.885C130.597 146.185 133.798 145.593 136.866 146.24C139.934 146.887 142.618 148.72 144.328 151.335C146.037 153.95 146.632 157.134 145.981 160.185C145.331 163.236 143.488 165.906 140.859 167.606Z",
    fill: "#389BF3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M287.985 72.4727L287.448 72.8289C286.146 73.6707 284.69 74.2492 283.163 74.5315C281.636 74.8137 280.068 74.794 278.549 74.4737C277.03 74.1533 275.589 73.5385 274.309 72.6643C273.029 71.7901 271.934 70.6737 271.088 69.3788C270.241 68.0839 269.66 66.6359 269.376 65.1174C269.092 63.5989 269.112 62.0397 269.434 60.5288C269.756 59.0179 270.374 57.5849 271.253 56.3116C272.132 55.0383 273.255 53.9497 274.557 53.1078L275.094 52.7517C277.723 51.0516 280.924 50.4599 283.992 51.1069C287.06 51.7539 289.744 53.5866 291.454 56.2018C293.163 58.8169 293.758 62.0004 293.107 65.0518C292.457 68.1032 290.614 70.7726 287.985 72.4727Z",
    fill: "url(#paint0_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M298.504 147.528L208.671 205.4C206.042 207.101 202.841 207.692 199.773 207.045C196.705 206.398 194.021 204.566 192.311 201.95C190.602 199.335 190.007 196.152 190.658 193.1C191.308 190.049 193.151 187.38 195.78 185.679L285.613 127.807C286.915 126.965 288.371 126.387 289.898 126.105C291.425 125.823 292.993 125.842 294.512 126.163C296.031 126.483 297.472 127.098 298.752 127.972C300.032 128.846 301.127 129.962 301.973 131.257C302.82 132.552 303.401 134 303.685 135.519C303.969 137.037 303.949 138.597 303.627 140.107C303.305 141.618 302.687 143.051 301.808 144.325C300.929 145.598 299.806 146.687 298.504 147.528Z",
    fill: "#389BF3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M178.458 225.167L118.39 263.986C115.76 265.686 112.56 266.278 109.492 265.631C106.424 264.984 103.74 263.151 102.03 260.536C100.321 257.921 99.7258 254.737 100.376 251.686C101.027 248.634 102.87 245.965 105.499 244.265L165.612 205.446C166.914 204.604 168.37 204.026 169.896 203.743C171.423 203.461 172.991 203.481 174.51 203.801C176.029 204.122 177.47 204.736 178.75 205.611C180.03 206.485 181.125 207.601 181.971 208.896C182.818 210.191 183.4 211.639 183.683 213.157C183.967 214.676 183.947 216.235 183.625 217.746C183.303 219.257 182.685 220.69 181.806 221.963C180.927 223.237 179.805 224.325 178.503 225.167H178.458Z",
    fill: "#AA7DFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M325.583 130.034L325.046 130.39C323.744 131.232 322.288 131.81 320.761 132.092C319.235 132.375 317.667 132.355 316.148 132.035C313.08 131.388 310.396 129.555 308.686 126.94C306.977 124.325 306.382 121.141 307.033 118.09C307.683 115.038 309.526 112.369 312.155 110.669L312.692 110.313C313.994 109.471 315.45 108.892 316.977 108.61C318.504 108.328 320.072 108.348 321.591 108.668C323.11 108.988 324.551 109.603 325.831 110.477C327.111 111.351 328.206 112.468 329.052 113.763C329.899 115.058 330.48 116.506 330.764 118.024C331.048 119.543 331.028 121.102 330.706 122.613C330.384 124.124 329.766 125.557 328.887 126.83C328.008 128.103 326.885 129.192 325.583 130.034Z",
    fill: "url(#paint1_linear)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M214.535 3.73877H6.66992V294.835H214.535V3.73877Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M188.843 272.622V213.592",
    stroke: "#732E54",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M188.843 205.134V185.902",
    stroke: "#732E54",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M188.843 177.623V162.843",
    stroke: "#732E54",
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M198.913 4.45166H17.9036C10.4875 4.45166 4.47559 10.4309 4.47559 17.8068V282.193C4.47559 289.569 10.4875 295.548 17.9036 295.548H198.913C206.329 295.548 212.341 289.569 212.341 282.193V17.8068C212.341 10.4309 206.329 4.45166 198.913 4.45166Z",
    stroke: "#732E54",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9912 49.3247H161.895",
    stroke: "#732E54",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9912 74.1641H94.7555",
    stroke: "#732E54",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9912 123.891H94.7555",
    stroke: "#732E54",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9912 99.0049H152.943",
    stroke: "#732E54",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7842 261.848H154.914",
    stroke: "#732E54",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M230.155 38.2838C231.782 39.2381 233.203 40.5031 234.337 42.0059C235.47 43.5087 236.294 45.2196 236.76 47.0401C237.226 48.8607 237.325 50.7549 237.052 52.6138C236.779 54.4726 236.139 56.2594 235.169 57.8713L130.385 232.601L103.306 252.811L105.678 218.133L210.371 43.2252C211.339 41.6032 212.62 40.1878 214.14 39.0605C215.66 37.9332 217.39 37.1163 219.229 36.6569C221.068 36.1976 222.98 36.1048 224.856 36.3841C226.731 36.6633 228.532 37.3089 230.155 38.2838Z",
    fill: "url(#paint2_linear)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M131.909 227.748L105.098 247.736L107.47 212.879L131.909 227.748Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M229.618 37.9277C232.89 39.8795 235.251 43.0421 236.182 46.7223C237.113 50.4025 236.539 54.2998 234.586 57.5597L132.13 228.416L102.275 252.188L107.423 213.681L209.878 42.8691C211.841 39.6145 215.021 37.2667 218.721 36.3404C222.421 35.414 226.34 35.9849 229.618 37.9277V37.9277Z",
    stroke: "#732E54",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 293.517,
    y1: 65.1511,
    x2: 265.773,
    y2: 64.8561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B89CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEB8F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 331.115,
    y1: 122.712,
    x2: 303.371,
    y2: 122.417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B89CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEB8F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 103.306,
    y1: 144.519,
    x2: 237.134,
    y2: 144.519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#40D2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6986EC"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration);
export default __webpack_public_path__ + "static/media/illustration.68c9e6b9.svg";
export { ForwardRef as ReactComponent };